import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LIBRARY_SERVICE_METHOD } from "services/commonService";
import { apiRequest } from "services/ServiceUtil";

const SLICE = "CustomFilterSlice";
interface CustomFilterState {
  customFilters: { brand: FilterType[]; region: FilterType[] } | null;
  customFilterAppliedForAddAction: AppliedFilters;
}

interface AppliedFilters {
  brand: string[] | [];
  region: string[] | [];
}

interface FilterType {
  name: string;
  id: string;
}

const initialState: CustomFilterState = {
  customFilters: null,
  customFilterAppliedForAddAction: { brand: [], region: [] }
};

export const getSubRegion = createAsyncThunk(`${SLICE}/getSubRegion`, (data: any, thunkApi) => {
  return apiRequest(LIBRARY_SERVICE_METHOD.getSubRegion, {}, thunkApi);
});

export const getBrands = createAsyncThunk(`${SLICE}/getBrands`, (data: any, thunkApi) => {
  return apiRequest(LIBRARY_SERVICE_METHOD.getBrands, {}, thunkApi);
});

export const CustomFilters = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    setCustomFilters: (state, action) => {
      state.customFilters = action.payload;
    },
    setCustomFilterAppliedForAddAction: (state, action) => {
      state.customFilterAppliedForAddAction = action.payload;
    }
  }
});

export const { setCustomFilters, setCustomFilterAppliedForAddAction } = CustomFilters.actions;

export default CustomFilters.reducer;
